import { filterObjectValues } from 'helpers/filter'

import { RevivalObject } from 'models/revival'
import { IStatistic } from 'models/statistic'

import api from '../api'
import { GetRevivalListResponse, GetRevivalParams } from './types'

export const revivalApi = api.injectEndpoints({
  endpoints: build => ({
    getRevivalById: build.query<RevivalObject, RevivalObject['id']>({
      query: id => ({
        url: `/web/revival/${id}/`,
      }),
    }),
    getRevival: build.query<GetRevivalListResponse, GetRevivalParams>({
      query: params => ({
        url: `/web/revival/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    revivalStatistics: build.query<Array<IStatistic>, GetRevivalParams>({
      query: params => ({
        url: `/web/revival/statistics/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    generateRevivalExcel: build.mutation<void, GetRevivalParams>({
      query: params => ({
        url: `/web/revival/excel/`,
        params: filterObjectValues(params),
        cache: 'no-cache',
      }),
    }),
  }),
})
